export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/63804e52067aa76f.png"